import { useCallback, useEffect, useState } from 'react';
import { api } from '@/lib/api';

const EMPTY = { category: [], persona: [], region: [], zone: [], market: [] };

// Fetches admin-configurable dropdown lists (category / persona / region / zone / market).
// Returns the taxonomy lists plus a `refresh()` to reload after adding a new option.
export function useTaxonomies() {
    const [tax, setTax] = useState(EMPTY);

    const refresh = useCallback(() => {
        return api.get('/taxonomies')
            .then((r) => setTax({ ...EMPTY, ...(r.data || {}) }))
            .catch(() => { /* keep current */ });
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    return { ...tax, refresh };
}
